import React from 'react';

import { useNotificationsQuery } from '@frontend/api';
import {
  Empty,
  EmptyDescription,
  EmptyHeadline,
  Flex,
  EmptyDrawerIcon,
} from '@frontend/components';

import { useWebsocketFetchNewNotifications } from 'modules/notifications/data/hooks';

import NotificationFactory from './NotificationFactory';

interface NotificationsListProps {
  notifications?: unknown[];
  customEmptyComponent?: React.ReactNode;
}

const NotificationsList = ({
  notifications: notificationsFromProps,
  customEmptyComponent,
}: NotificationsListProps) => {
  const { data } = useNotificationsQuery({});
  const notificationsFromHook = data?.results || [];
  const notifications =
    notificationsFromProps ?? notificationsFromHook.slice(0, 10);
  useWebsocketFetchNewNotifications();

  return (
    <Flex w="100%" flexDir="column" flex="1 1 100%">
      {notifications.length > 0 ? (
        notifications.map((notification) => {
          if (notification)
            return (
              <NotificationFactory
                key={`notification-id-${notification.id}`}
                notification={notification}
              />
            );
          else return null;
        })
      ) : customEmptyComponent ? (
        customEmptyComponent
      ) : (
        <Empty padding={2} size="md">
          <EmptyDrawerIcon size={4} />
          <EmptyHeadline>No notifications yet</EmptyHeadline>
          <EmptyDescription>
            Updates on team and customer activity will appear here.
          </EmptyDescription>
        </Empty>
      )}
    </Flex>
  );
};

export default NotificationsList;
